import { Field } from 'SourceUtil/Query';

export class ReviewsQuery {
    getReviewsListQuery(id, page, details) {
        return new Field('products')
            .addArgument('filter', 'ProductAttributeFilterInput!', { sku: { eq: id } })
            .addFieldList(this.getReviewsListFields(page, details));
    }

    getCustomerReviewsQuery(customer_email) {
        return new Field('reviewsCustomer')
            .addArgument('customer_email', 'String!', customer_email)
            .addFieldList(this.getReviewsListCustomerFields());
    }

    getReviewsListFields(page, details) {
        return [
            this.getReviewsItemsField(page, details)
        ];
    }

    getReviewsListCustomerFields() {
        return [
            this.getReviewsItemsCustomerField()
        ];
    }

    getReviewsItemsCustomerField() {
        return new Field('reviews')
            .addFieldList(this._getReviewFields());
    }

    getReviewsItemsField(page, details) {
        return new Field('items')
            .addFieldList(this.getReviewsItemsFields(page, details));
    }

    getReviewsItemsFields(page, details) {
        return [
            this.getReviewsDetailField(page, details)
        ];
    }

    getReviewsDetailField(page, details) {
        return new Field(`reviewsList(pageSize:5, currentPage: ${ page }, sex: ${ details.sex ? `"${details.sex}"` : null}, age: ${ details.age }, tip_ten: ${ details.tip_ten ? `"${details.tip_ten}"` : null}, tip_par: ${ details.tip_par ? `"${details.tip_par}"` : null})`)
            .addFieldList(this._getReviewListFields());
    }

    _getReviewListFields() {
        return [
            this._getReviewsField(),
            'total_pages'
        ]
    }

    _getReviewFields() {
        return [
            'review_id',
            'nickname',
            'title',
            'detail',
            'created_at',
            'product_name',
            'product_url',
            'product_thumbnail',
            'tip_par',
            'tip_ten',
            'sex',
            'age',
            'verified_sale',
            this._getRatingVotesField()
        ];
    }

    _getReviewsField() {
        return new Field('reviews')
            .addFieldList(this._getReviewFields());
    }

    _getRatingVoteFields() {
        return [
            'vote_id',
            'rating_code',
            'percent'
        ];
    }

    _getRatingVotesField() {
        return new Field('rating_votes')
            .addFieldList(this._getRatingVoteFields());
    }

}


export default new ReviewsQuery();
